import React from 'react';

import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import LastPlayedGames from '@/pages/games/lobby/lobby-sections-streamlines/LastPlayedGames';
import AllGames from '@/pages/games/lobby/lobby-sections-streamlines/AllGames';
import SlotsSingleStreamline from '@/pages/games/lobby/lobby-sections-streamlines/SlotsSingleStreamline';
import TopGameProviders from '@/pages/games/lobby/lobby-sections-streamlines/TopGameProviders';
import SlotsGameProviders from '@/pages/games/lobby/lobby-sections-streamlines/SlotsGameProviders';
import BuyFeatureGameProviders from '@/pages/games/lobby/lobby-sections-streamlines/BuyFeatureGameProviders';

function GamesLobbyThailand(): JSX.Element {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <div
      id="e2e_sections_container"
      className="py-16 flex flex-col gap-16 max-w-container mx-auto px-4 md:px-8"
    >
      {isAuthenticated && <LastPlayedGames />}
      <TopGameProviders />
      <BuyFeatureGameProviders />
      <SlotsGameProviders />
      <SlotsSingleStreamline />
      <AllGames />
    </div>
  );
}

export default GamesLobbyThailand;
